import { render, staticRenderFns } from "./NfcReportTable.vue?vue&type=template&id=b35e7ae4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./NfcReportTable.vue?vue&type=script&lang=js"
export * from "./NfcReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e7ae4",
  null
  
)

export default component.exports